import { Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { ImodalsWrapperProps } from "src/Types/module/common/commonTypes";

const ModalsWrapper = ({
	children,
	showModal,
	setShowModal,
	modalData,
	maxWidth = "sm",
}: ImodalsWrapperProps) => {
	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

	return (
		<div>
			<Dialog
				fullScreen={fullScreen}
				open={showModal}
				onClose={() => {
					return setShowModal(!showModal);
				}}
				aria-labelledby="responsive-dialog-title"
				fullWidth
				maxWidth={maxWidth}
			>
				<DialogTitle
					mt={2}
					id="responsive-dialog-title"
					sx={{ paddingBottom: "0px !important" }}
				>
					<Typography variant="h4" style={{ textAlign: "center" }}>
						{modalData?.title}
					</Typography>
				</DialogTitle>
				<DialogContent>{children}</DialogContent>
			</Dialog>
		</div>
	);
};

export default ModalsWrapper;
